module.exports = __webpack_public_path__ + "img/buddy_arm.2e6f2344.svg";